(() => {
  angular
    .module('app.settings')
    .controller('AdformPpasEditModalController', AdformPpasEditModal);

  AdformPpasEditModal.$inject = [
    'close',
    'provider',
    'integrations',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function AdformPpasEditModal(
    close,
    provider,
    integrations,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;
    let originCountry = 'DK';
    let originMetrics = [];

    vm.saveEnable = () => vm.countryEdited || vm.metricsEdited;

    vm.loadIntegrations = () => {
      vm.isProcessBusy = true;

      provider.fetchIntegrations()
        .then(({ data }) => {
          initIntegrations(data);
        })
        .catch(error => {
          console.error(error.statusText);
        })
        .finally(() => {
          vm.isProcessBusy = false;
        });
    }

    function initIntegrations(data) {
      $('html').scrollTop(0);

      const {
        country,
        qualityMetrics,
        lastIntegrationDateUTC,
        clickUrl,
        impressionUrl,
        lastErrorDate,
        lastErrorMessage,
      } = data;

      originCountry = country;
      originMetrics = qualityMetrics || [];

      vm.pixel = {
        click: clickUrl,
        impression: impressionUrl,
      };

      vm.lastErrorDate = lastErrorDate && new Date(lastErrorDate);
      vm.lastErrorMessage = lastErrorMessage;
      vm.lastIntegrationDate = lastIntegrationDateUTC && new Date(lastIntegrationDateUTC);

      initCountries();
      initMetrics();
    };
    initIntegrations(integrations);



    /* ************************************************************* */
    /* *************************** Pixels ************************** */
    /* ************************************************************* */
    vm.onCopy = pixel => {
      const input = document.querySelector(`input[data-copy="${pixel}"]`);
      input.select();
      document.execCommand('copy');
    };



    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    function initCountries() {
      vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
      vm.currentCountry = vm.countries.find(item => item.code === originCountry);
    };

    vm.onSelectCountry = country => {
      vm.currentCountry = country;
      vm.countryEdited = country.code !== originCountry;
    };


    /* ************************************************************* */
    /* *************************** Quality ************************* */
    /* ************************************************************* */
    function initMetrics() {
      vm.metrics = allowedMetrics.map(item => ({
        ...item,
        checked: originMetrics && originMetrics.includes(item.key),
      }));
    }

    const onEditMetrics = () => {
      const selectedMetrics = vm.metrics.filter(item => item.checked).map(item => item.key);
      vm.metricsEdited = (originMetrics && !_.isEqual(selectedMetrics.sort(), originMetrics.sort())) ||
        (!originMetrics && selectedMetrics.length !== 0);
    };

    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
      onEditMetrics();
    };



    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onSave = () => {
      vm.isProcessBusy = true;
      provider.updateIntegrations({
        country: vm.currentCountry.code,
        qualityMetrics: vm.metrics.filter(item => item.checked).map(item => item.key),
      })
      .then(data => {
        close(true, 0);
      })
      .catch(error => {
        console.error(error);
        if (error.status === 400) {
          // const message = /\[(.*?)\]/.exec(error.data.message);
        }
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };

    vm.onClose = () => close(false, 0);

    const collapsed = {
      pixels: false,
      country: true,
      quality: true,
    };
    vm.sectionCollapsed = section => collapsed[section];
    vm.onSectionCollapse = section => collapsed[section] = !collapsed[section];
  }
})();
